module.exports = __webpack_public_path__ + "assets/img/part1.30c1180e.png";